import { render, staticRenderFns } from "./CustomerTypeChip.vue?vue&type=template&id=60850186&scoped=true"
import script from "./CustomerTypeChip.vue?vue&type=script&lang=ts"
export * from "./CustomerTypeChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60850186",
  null
  
)

export default component.exports